import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout'
import Login from '@/views/Login'

import Requirement from '@/views/requirement/Index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Layout',
      component: Layout,
      path:'/',
      children: [
        {
          path: 'requirement',
          component: Requirement,
          name:'Requirement'
        },
        {
          path: 'production',
          component: Requirement,
          name:'Production'
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js